import { NavLink, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, AlertTriangle, FileText, Bot } from 'lucide-react';
import { cn } from '@/shared/lib/utils';
import { ROUTES } from '@/shared/config/routes';

const BOTTOM_NAV_ITEMS = [
  { label: 'nav.dashboard', icon: LayoutDashboard, path: ROUTES.DASHBOARD },
  { label: 'nav.quality_issues', icon: AlertTriangle, path: ROUTES.QUALITY_ISSUES },
  { label: 'nav.documents', icon: FileText, path: ROUTES.DOCUMENTS },
  { label: 'nav.ai_assistant', icon: Bot, path: ROUTES.AI_ASSISTANT },
] as const;

export function BottomNav() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <nav className="fixed inset-x-0 bottom-0 z-20 flex h-16 items-center border-t border-border bg-background lg:hidden">
      {BOTTOM_NAV_ITEMS.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path ||
          (item.path !== '/' && location.pathname.startsWith(item.path));

        return (
          <NavLink
            key={item.path}
            to={item.path}
            className={cn(
              'flex flex-1 flex-col items-center justify-center gap-1 text-xs transition-colors',
              isActive
                ? 'text-primary'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            <Icon className="h-5 w-5" strokeWidth={1.5} />
            <span>{t(item.label)}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
